import { IFacility } from 'es/app/business-logic/domain-models/Facility';
import ApolloProvider from 'es/core/net/ApolloProvider';
import { ICompany } from '../../domain-models/ICompany';
import { FETCH_ACCESSIBLE_SITES } from './graphql/fetchAccessibleSites';
import Site from 'es/app/business-logic/domain-models/Site';
import { FetchAccessibleSitesQuery, FetchAccessibleSitesQueryVariables } from 'es/app/__generated__/global';

interface IAccessibleSites {
    companies: ICompany[];
    facilities: IFacility[];
}

export async function fetchAccessibleSites(): Promise<IAccessibleSites> {
    const { data } = await ApolloProvider.root.query<FetchAccessibleSitesQuery, FetchAccessibleSitesQueryVariables>({
        query: FETCH_ACCESSIBLE_SITES,
    });

    const companies: ICompany[] = [];
    const facilities: IFacility[] = [];

    data?.system?.companies.forEach(company => {
        const { id: companyId, name: companyName, alias: companyAlias } = company;

        companies.push({
            id: companyId,
            name: companyName,
            alias: companyAlias,
        });

        company?.facilities.forEach(facility => {
            const {
                id,
                alias,
                name,
                windowsTimezone,
                ianaTimezone,
                passwordResetFrequencyDays,
                smaxCustomerCode,
                smaxStaleDataTimeoutSeconds,
                facilityCode,
                latitude,
                longitude,
                region,
                type,
                defaultZoomLevel,
                processDataRetentionInDays,
                isActive,
                useImperialUnits,
            } = facility;

            // TODO: 4/02/2020 - gerrod.thomas - Add 'isOffline' to the graph
            // For now we will fake it - ff the facility has no timezone it means the DB isn't available.
            if (!(windowsTimezone || ianaTimezone)) return;

            facilities.push({
                id,
                name,
                companyId,
                companyName,
                ianaTimeZoneId: ianaTimezone,
                windowsTimeZoneId: windowsTimezone,
                site: Site.get(companyAlias, alias),
                passwordResetFrequencyDays,
                smaxCustomerCode,
                facilityCode,
                smaxStaleDataTimeoutSeconds,
                latitude,
                longitude,
                region,
                type,
                defaultZoomLevel,
                processDataRetentionInDays,
                isActive: isActive ?? false,
                useImperialUnits: useImperialUnits ?? false,
            });
        });
    });

    return { companies, facilities };
}
